import { Select } from 'antd';
import { useContext, useEffect, useState } from 'react';
import APIList from '../../../../http/ApiList';
import { AppContext } from '../../../../contexts/AppContext';
import { GLOBAL_EVENT } from '../../../../consts/common/global-event';

const DraggableSelect: React.FC<any> = (props) => {
  const { authInfo, globalEvent } = useContext(AppContext);
  const { property } = props;
  const [selectOptions, setSelectOptions] = useState([]);

  const getSelectData = (event: string) => {
    APIList.getCustomizeLayoutData()
      .post({ email: authInfo?.user?.attributes?.email || '', property, event })
      .then((res: any) => {
        console.log('get select data', res);
        if (res.data) {
          setSelectOptions(res.data);
        }
      });
  };

  useEffect(() => {
    if (!globalEvent) {
      return;
    }
    if (
      (property.dataSource &&
        property.dataSource.triggerEvent &&
        property.dataSource.triggerEvent.find((triggerEvent) => {
          return triggerEvent.event === globalEvent.eventType;
        })) ||
      globalEvent.eventType === GLOBAL_EVENT.PAGE_INIT
    ) {
      setTimeout(() => {
        getSelectData(globalEvent);
      }, 500);
    }
  }, [globalEvent]);

  return (
    <>
      <Select
        mode={property.multiple ? 'multiple' : null}
        maxCount={property.maxCount}
        showSearch={property.showSearch}
        allowClear
        disabled={property.disabled}
        size={property.size}
        placeholder={property.placeholder}
        style={{ width: property.width }}
        options={selectOptions.map((item) => ({ label: item, value: item }))}
      />
    </>
  );
};

export default DraggableSelect;
